export default "__VITE_ASSET__BHJPqA3K__"